import React from "react";
import * as css from "./style.module.less";
import AppCapabilitiesCard from "./components/app-capabilities-card";
import CommonHeader from "../../components/common-header";

const AddAppCapabilities = (props) => {
  return (
    <div className={css['add-app-capabilities-container']}>
      <CommonHeader
        title="添加应用能力"
        desc={[
          "你可以根据实际需求，为应用开启能力，单个应用可开启多个能力，一个能力可用于一个或多个场景。",
          {
            text: "如果尚不能确定需要添加什么能力，可切换至“按场景添加”，根据所需的业务场景选择能力。",
            moreText: "了解更多",
            moreUrl: `https://${location.hostname}/docs/#/990hh0/whokyc/kh6z6j`
          }
        ]}
      />
      <AppCapabilitiesCard {...props} />
    </div>
  );
};

export default AddAppCapabilities;
